import React from "react";

export default function Missing() {
  return <div>Page not found</div>;
}
